import { z } from "zod";

import { oauthRefreshSchema } from "../../../../../types";

export const registerSchema = z.object({
  oauth: oauthRefreshSchema,
});

export type Register = z.TypeOf<typeof registerSchema>;
